// import editor from '@/API/services/editor';
import _ from "lodash";

export default {
  state: {
    qitem: null,
    datapaths: {},
    selectedDatapath: null,
    sendData: {
      paths: [],
    },
    currentStep: "",
  },
  mutations: {
    CLEAR_QUEUE_ITEM: (state) => {
      state.qitem = null
    },
    CLEAR_DATAPATH: (state) => {
      state.datapaths = {}
    },
    CLEAR_SELECTED_DATAPATH: (state) => {
      state.selectedDatapath = null
    },
    CLEAR_SENDDATA_PATHS: (state) => {
      state.sendData.paths = []
    },
    UPDATE_QUEUE_ITEM: (state, payload) => {
      state.qitem = payload;
    },
    UPDATE_DATAPATH: (state, payload) => {
      state.datapaths[state.selectedDatapath] = payload.path
    },
    UPDATE_DATA_MAPPER_LABELS: (state, payload) => {
      state.sendData.paths = payload
    },
    REMOVE_DATA_MAPPER_LABEL: (state, payload) => {
      state.sendData.paths = state.sendData.paths.filter((path) => {
        return path.label !== payload
      })
    },
    UPDATE_SELECTED_DATAPATH: (state, payload) => {
      state.selectedDatapath = payload
    },
    ADD_TAG: (state, payload) => {
      const tagExists = _.some(state.sendData.paths, ['label', payload.label])
      if(tagExists) {
        state.sendData.paths[payload.label] = payload
      } else {
        state.sendData.paths.push(payload)
      }
    },
    SET_CURRENT_STEP: (state, payload) => {
      state.currentStep = payload.replace('steps.', '')
    },
  },
  actions: {
    setCurrentStep: ({ commit }, payload) => {
      commit('SET_CURRENT_STEP', payload)
    },
    clearDataMapperData: ({ commit }) => {
      commit('CLEAR_QUEUE_ITEM')
      commit('CLEAR_DATAPATH')
      commit('CLEAR_SELECTED_DATAPATH')
      commit('CLEAR_SENDDATA_PATHS')
    },
    updateQueueItem: ({ commit }, payload) => {
      commit('UPDATE_QUEUE_ITEM', payload)
    },
    updateDataPath: ({ commit }, payload) => {
      commit('UPDATE_DATAPATH', payload)
    },
    updateDataMapperLabels: ({ commit }, payload) => {
      commit('UPDATE_DATA_MAPPER_LABELS', payload)
    },
    updateSelectedDatapath: ({ commit }, payload) => {
      commit('UPDATE_SELECTED_DATAPATH', payload)
    },
    addTag: ({ commit }, payload) => {
      commit('ADD_TAG', payload)
    },
    removedDataMapperLabel: ({ commit }, payload) => {
      commit('REMOVE_DATA_MAPPER_LABEL', payload)
    },
  },
  getters: {
    dataMapperLabels: (state) => {
      if(state.sendData && state.sendData.paths) {
        return state.sendData
      } else {
        return []
      }
    },
  },
};
